import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  CREATE_PATIENT,
  GET_ASSIGNED_DOCTOR_LIST,
  GET_CC_PAPER_DETAIL,
  GET_CC_PAPER_VERIFICATION_DETAIL,
  GET_CUSTOMER_BIRTHDATE_DETAIL,
  GET_CUS_DASHBOARD,
  GET_LABORATORY_DATA,
  GET_MEDICAL_DETAIL,
  GET_PATIENT_BY_ID,
  GET_PATIENT_CONFIRMATION_DETAIL,
  GET_PATIENT_LIST,
  MEDICINE_LIST,
  UPDATE_PATIENT,
  CREATE_PATIENT_CONFIRMATION_DETAIL,
  GET_MEMBERSHIP_HISTORY,
  DELETE_PATIENT,
} from '../storeTypes';
import {
  CreatePatientApi,
  GetAssignedDoctorApi,
  GetCCPaperDetailApi,
  GetCCPaperVerificationDetailApi,
  GetCustomerBirthDateDetailApi,
  GetCustomerConfirmationApi,
  GetCustomerDashboardApi,
  GetMedicalDetailApi,
  GetMedicineListApi,
  GetPatientApi,
  GetlaboratoryApi,
  UpdateByCustomerIdApi, CreateCustomerConfirmationApi,
  GetCustomerMembershipHistoryApi,
  DeleteCustomerApi
} from '../../utils/api';
import {
  ActionGetCCPaperDetailSuccess,
  ActionGetCCPaperVerificationDetailSuccess,
  ActionGetCustomerBirthdateDetailSuccess,
  ActionGetMedicineListSuccess,
  ActionGetPatientByIdSuccess,
  ActionGetPatientListSuccess,
  ActionGetlaboratorySuccess,
  GetAssignedDoctorListSuccess,
  GetCustomerDashboardSuccess,
  GetMedicalDetailSuccess, GetPatientConfirmationDetailSuccess,
  ActionGetMembershipHistorySuccess,
  ActionDeletePatientSuccess
} from '../Actions/PatientAction';
import { handleApiResponse } from '../../utils/functions';

const File = 'PatientSaga ';
function* GetPatientSaga(action) {
  try {
    const response = yield call(GetPatientApi, action.payload);
    if (response?.status == 200) {
      yield put(ActionGetPatientListSuccess(response?.data?.data));
    }
  } catch (error) {
    // yield put(handleError());
  }
}
function* GetPatientByIdSaga(action) {
  try {
    const response = yield call(GetPatientApi, action.payload);
    if (response?.status == 200) {
      yield put(ActionGetPatientByIdSuccess(response?.data?.data));
    }
  } catch (error) {
    // yield put(handleError());
  }
}
function* CreatePatientSaga(action) {
  try {
    const response = yield call(CreatePatientApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(response);
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
  }
}
function* UpdatePatientSaga(action) {
  try {
    const response = yield call(UpdateByCustomerIdApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(response?.data);
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* GetlaboratorySaga(action) {
  try {
    const response = yield call(GetlaboratoryApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetlaboratorySuccess(response?.data?.data));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
  }
}

function* GetMedicineListSaga(action) {
  try {
    const response = yield call(GetMedicineListApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetMedicineListSuccess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}
function* GetCCPaperDetailSaga(action) {
  try {
    const response = yield call(GetCCPaperDetailApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetCCPaperDetailSuccess(response?.data?.data));
      if (action?.callBack) {
        action?.callBack(response?.data);
      }
    }
  } catch (error) {
    if (error?.response?.status === 400 && action?.callBack) {
      action?.callBack(error?.response?.data);
    }
  }
}
function* GetCustomerBirthdateDetailSaga(action) {
  try {
    const response = yield call(GetCustomerBirthDateDetailApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetCustomerBirthdateDetailSuccess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}
function* GetCCPaperVerificationDetailSaga(action) {
  try {
    const response = yield call(GetCCPaperVerificationDetailApi, action.payload);
    // console.log("GetCCPaperVerificationDetailApi", response?.data);
    if (response?.status === 200) {
      yield put(ActionGetCCPaperVerificationDetailSuccess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}
function* GetCustomerDashboardSaga(action) {
  try {
    const response = yield call(GetCustomerDashboardApi, action.payload);
    if (response?.status === 200) {
      yield put(GetCustomerDashboardSuccess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack?.(error?.response?.data);
    }
  }
}
function* GetCustomerConfirmationSaga(action) {
  try {
    const response = yield call(GetCustomerConfirmationApi, action.payload);
    if (response?.status === 200) {
      yield put(GetPatientConfirmationDetailSuccess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack?.(error?.response?.data);
    }
  }
}
function* CreatePatientConfirmationSaga(action) {
  try {
    const response = yield call(CreateCustomerConfirmationApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(response?.data);
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}
function* GetMedicalDetailSaga(action) {
  try {
    const response = yield call(GetMedicalDetailApi, action.payload);
    if (response?.status === 200) {
      yield put(GetMedicalDetailSuccess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* GetAssignedDoctorSaga(action) {
  try {
    const response = yield call(GetAssignedDoctorApi, action.payload);
    if (response?.status === 200) {
      yield put(GetAssignedDoctorListSuccess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* GetMembershipHistorySaga(action) {
  try {
    const response = yield call(GetCustomerMembershipHistoryApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetMembershipHistorySuccess(response?.data?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* DeletePatientSaga(action) {
  try {
    const response = yield call(DeleteCustomerApi, action.payload);
   console.log("DeletePatientSaga-----", response);
   
    if (response?.status === 200) {
      yield put(ActionDeletePatientSuccess(response?.data));
      action?.callBack(response?.data);
    }
  } catch (error) {
    yield put(ActionDeletePatientSuccess());
    if (error?.response) {
      action?.callBack(error?.response?.data);
    } else {
      action?.callBack({ success: false, message: error?.message || 'Something went wrong' });
    }
  }
}

export function* PatientSaga() {
  yield all([
    takeEvery(GET_PATIENT_LIST, GetPatientSaga),
    takeEvery(GET_PATIENT_BY_ID, GetPatientByIdSaga),
    takeEvery(UPDATE_PATIENT, UpdatePatientSaga),
    takeEvery(CREATE_PATIENT, CreatePatientSaga),
    takeEvery(MEDICINE_LIST, GetMedicineListSaga),
    takeEvery(GET_LABORATORY_DATA, GetlaboratorySaga),
    takeEvery(GET_CC_PAPER_DETAIL, GetCCPaperDetailSaga),
    takeEvery(GET_CUS_DASHBOARD, GetCustomerDashboardSaga),
    takeEvery(GET_PATIENT_CONFIRMATION_DETAIL, GetCustomerConfirmationSaga),
    takeEvery(GET_MEDICAL_DETAIL, GetMedicalDetailSaga),
    takeEvery(GET_CUSTOMER_BIRTHDATE_DETAIL, GetCustomerBirthdateDetailSaga),
    takeEvery(GET_CC_PAPER_VERIFICATION_DETAIL, GetCCPaperVerificationDetailSaga),
    takeEvery(GET_ASSIGNED_DOCTOR_LIST, GetAssignedDoctorSaga),
    takeEvery(CREATE_PATIENT_CONFIRMATION_DETAIL, CreatePatientConfirmationSaga),
    takeEvery(GET_MEMBERSHIP_HISTORY, GetMembershipHistorySaga),
    takeEvery(DELETE_PATIENT, DeletePatientSaga),
  ]);
}
